<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
        <section>
          <h1 class="section-heading">
            {{ "COMPANY_ADDITIONAL_INFO.TITLE" | translate }}
          </h1>
          <h1 class="text-2xl font-semibold px-2">
            {{ "COMPANY_ADDITIONAL_INFO.SUBTITLE" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="
                  'COMPANY_ADDITIONAL_INFO.LEGAL_COMPANY_NAME' | translate
                "
                [control]="form.get('companyName')!"
                [maxlength]="250"
              />
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'COMPANY_ADDITIONAL_INFO.INDUSTRY' | translate"
                [control]="form.get('industry')!"
                [lovType]="lookupKey.DC_SECTOR_INDUSTRY"
              ></app-option-field>
            </div>

            @if (showOtherIndustry) {
              <div class="field-control">
                <app-text-field
                  [label]="'COMPANY_ADDITIONAL_INFO.OTHER_INDUSTRY' | translate"
                  [control]="form.get('otherIndustry')!"
                  [maxlength]="100"
                ></app-text-field>
              </div>
            }

            <div class="field-control">
              <app-option-field
                [label]="'COMPANY_ADDITIONAL_INFO.EMPLOYEES' | translate"
                [control]="form.get('employees')!"
                [lovType]="lookupKey.DC_NUM_OF_EMP"
              ></app-option-field>
            </div>

            <div class="field-control">
              <app-text-field
                [label]="'COMPANY_ADDITIONAL_INFO.WEBSITE_URL' | translate"
                [control]="form.get('websiteURL')!"
                [maxlength]="100"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'COMPANY_ADDITIONAL_INFO.LINKEDIN_URL' | translate"
                [control]="form.get('linkedInURL')!"
                [maxlength]="100"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'COMPANY_ADDITIONAL_INFO.OTHER_URL' | translate"
                [control]="form.get('otherURL')!"
                [maxlength]="100"
              ></app-text-field>
            </div>
          </div>
        </section>
        <section>
          <h1 class="section-heading">
            {{ "COMPANY_ADDITIONAL_INFO.BUSINESS_OBJECTIVES" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-option-field
                [label]="
                  'COMPANY_ADDITIONAL_INFO.BUSINESS_PRIORITIES' | translate
                "
                [control]="form.get('businessPriorities')!"
                [lovType]="lookupKey.DC_BUSNS_PRIORITY"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                [isMultiple]="true"
                [maxSelectLimit]="3"
              ></app-option-field>
            </div>
          </div>
        </section>
        <section>
          <h1 class="section-heading">
            {{
              "COMPANY_ADDITIONAL_INFO.COMMUNICATION_PREFERENCES" | translate
            }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-option-field
                [label]="
                  'COMPANY_ADDITIONAL_INFO.COMMUNICATION_CHANNEL' | translate
                "
                [control]="form.get('communicationChannel')!"
                [lovType]="lookupKey.DC_COMM_CHANNEL"
              ></app-option-field>
            </div>
            <div class="field-control">
              <app-boolean
                [label]="'COMPANY_ADDITIONAL_INFO.INDUSTRY_SURVEYS' | translate"
                [control]="form.get('industrySurveys')!"
                [options]="standardOption"
              ></app-boolean>
            </div>
            <div class="field-control">
              <app-boolean
                [label]="
                  'COMPANY_ADDITIONAL_INFO.RECEIVE_PROMOTIONS' | translate
                "
                [control]="form.get('receivePromotions')!"
                [options]="standardOption"
              ></app-boolean>
            </div>

            <!-- Technical error msg -->
            <div class="fields-container">
              @if (technicalErrorMsg) {
                <app-validation-message
                  [type]="'error'"
                  [content]="{
                    title: 'VALIDATION_MSG.ERROR' | translate,
                    message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
                  }"
                  [showbutton]="false"
                ></app-validation-message>
              }
            </div>

            <div class="btn-section buttons-group">
              @if (!formSubmitLoader) {
                <app-button
                  type="button"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'BUTTONS.SUBMIT' | translate"
                  (onBtnClick)="submit()"
                ></app-button>
                <app-button
                  type="button"
                  classesName="card-edge-cut-white btn-width-auto"
                  [label]="'BUTTONS.SAVE_CLOSE' | translate"
                  (onBtnClick)="saveAndClose()"
                ></app-button>
              }
              @if (formSubmitLoader) {
                <app-button
                  type="button"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'PLEASE_WAIT' | translate"
                  [disabled]="true"
                ></app-button>
              }
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
